import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
// middlewares
import { Button, Modal } from "react-bootstrap";
import CashSalesMiddleware from "../../../../middleware/modules/sales/cash-sales";
import Form from "../../../../components/modules/sales/cash-sales/form";
import { Helmet } from "react-helmet";
import i18n from "../../../../i18n";

const mapStateToProps = ({ auth, cashSales }) => ({
  isAuthenticated: auth.isAuthenticated,
  isProcessing: cashSales.isProcessing,
  isError: cashSales.isError,
  errorMessage: cashSales.errorMessage,
  data: cashSales.listCash,
  type: cashSales.type,
  isSuccess: cashSales.isSuccess,
  isReset: cashSales.isReset,
  helper:cashSales.helperCashSales,
  single:cashSales.single,
  isNewRecord: cashSales.isNewRecord,
  onSubmit: cashSales.onSubmit,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      closeModal: () => CashSalesMiddleware.reset(),
      save: (data, search) => CashSalesMiddleware.beforeSave(data, search),
      },
    dispatch
  );
};
class FormContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    isSuccess: PropTypes.bool,
    errorMessage: PropTypes.any,
    onSubmit: PropTypes.bool,
    type: PropTypes.string,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isSuccess: false,
    isError: false,
    errorMessage: [],
    type: "multiple",
    onSubmit: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      modal: {
        title: "",
        show: false,
      },
    };
    this.form = React.createRef();
    this.submitForm = this.submitForm.bind(this);
    this.close = this.close.bind(this);
  }

  close() {
    this.props.closeModal();
  }
  submitForm() {
    const { search, isNewRecord, dataUpdate } = this.props;
    var form = this.form.current.runSubmit();
    if(form.details.idCash.length > 0){
      this.props.save(form, search);
    }else{
      alert(i18n.t("Must Choose atleast 1 transaction"))
    }
    
  }
  render() {
    const { onSubmit, showModal, titleModal } = this.props;

    return (
      <>
        <Modal show={showModal} size={"xl"}enforceFocus={false}>
          <Modal.Header>
            <Modal.Title>{titleModal}</Modal.Title>
          </Modal.Header>
          <Helmet>
            <title>{titleModal}</title>
          </Helmet>
          <Modal.Body>
            <Form {...this.props} ref={this.form} />
          </Modal.Body>
          <Modal.Footer
            className={
              !onSubmit ? "justify-content-between" : "justify-content-center"
            }
          >
            {onSubmit ? (
              ""
            ) : (
              <Button variant="secondary" onClick={() => this.close(false)}>
                {i18n.t("Close")}
              </Button>
            )}
            <Button
              variant="primary"
              onClick={() => (onSubmit ? false : this.submitForm(true))}
            >
              {onSubmit ? (
                <span className="indicator-progress show">
                  {i18n.t("Please wait...")}
                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
              ) : (
                <span className="indicator-label">{i18n.t("Save")}</span>
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContainer);
